module.exports = __webpack_public_path__ + "img/shui.2112b2ab.png";